/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'

import * as Comm from "rpc/Comm/Comm"
export var TABLE_SPEC_customCompanyStat = "customCompanyStat";
export var TABLE_SPEC_skuStat = "skuStat";
export var TABLE_SPEC_salesmanStat = "salesmanStat";
export var TABLE_SPEC_collectedPayment = "collectedPayment";
export var TABLE_SPEC_uncollectedPayment = "uncollectedPayment";
export var TABLE_SPEC_statOrder = "statOrder";
export var TABLE_SPEC_statOrderSku = "statOrderSku";

export class OperationIndicator {
    constructor() {
        this.receivableNormal = 0.0;  // 0 require
        this.receivableOverdue = 0.0;  // 1 require
        this.invTotalCost = 0.0;  // 2 require
        this.invAverageTotalCost = 0.0;  // 3 require
        this.prevMonthOrderAmount = 0.0;  // 4 require
        this.prevMonthGrossProfit = 0.0;  // 5 require
        this.note = "";  // 6 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

OperationIndicator.__json_class__ = 'MisStat.OperationIndicator'

export class MisStatInterfApi extends BaseInterfApi {
    constructor(baseUrl, moduleName='MisStat',
            interfName='MisStatInterf', token='anonymous', ...args) {
        super(baseUrl, moduleName, interfName, token, ...args)
    }


    getOperationIndicator( context) {
        let params = {
            };
        let req = this.createRequest('getOperationIndicator', params);
        var _this = this;
        var respPromise = req.request();

        return new Promise(function (resolve, reject) {
            respPromise.then(function(resp) {
                _this.fillContext(context, resp.json);
                let robj = resp.json['data'];
                try {
                    resolve(robj);
                } catch (err) {
                    reject(new RpcSerializeError('getOperationIndicator'+err.message));
                }
            }, function(err) {
                console.log("error " + err.message);
                reject(err);
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/apis/rpc/MisStat/MisStat.js